module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAAMZJREFUWAntl0sKAjEQRKc1CN7HG7jwGi481lzDhYfwPIL4IxvpEWJN6cyioLLq0JWkePnHtr8+O4WiYLR6XCjArB5ljJYW0V1/+bp2S1lujvvVubafS5u9yRC10TxtU8QmOgXF3Edz10fEPQs/49uje58Kc2kHY/pmGuD4v9Kc+tw1OtCz9pf4dFgHauddjwixeRNliSG9iSJCbN5EWWJIb6KIEJs3UZYY0psoIsTmZYiOeo+OeS+yhFi9DFEZo6HwuavL5AU/OzFn1kvIhgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/mixers/QuickSelection-03.png
// module id = 1073
// module chunks = 2